import styled, { css } from 'styled-components';

const getColorHover = (metric: string) => {
  if (metric) {
    return css`
      fill-opacity: 0.8;
    `;
  }

  return css`
    fill: #9493a6;
  `;
};

const StyledUsaMapChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

type MapFeatureSvgProps = {
  metric?: string;
  selectable: boolean;
};

const StyledMapFeatureSvg = styled.svg<MapFeatureSvgProps>`
  cursor: ${(props: any) => props.selectable && 'pointer'};

  & path:hover {
    ${(props: any) => props.selectable && getColorHover(props.metric)};
  }
`;

const getTriangle = () => {
  return css`
    &::after {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 6px 4px 0 4px;
      border-color: rgb(58, 57, 73) transparent transparent transparent;
      z-index: 1;
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translate(-50%, 0);
    }
  `;
};

const getPosition = (left: number, top: number) => {
  return `
    position: absolute;
    top: ${top}px;
    left: ${left}px;
    transform: translate(-50%, calc(-100% - 12px));
  `;
};

type UsaMapChartTooltipProps = {
  top?: number;
  left?: number;
};

const StyledUsaMapChartTooltip = styled.div<UsaMapChartTooltipProps>`
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  text-align: left;
  width: max-content;
  max-width: 250px;
  white-space: pre-line;
  font-size: 11px;
  line-height: 18px;
  color: #ffffff;
  background-color: rgb(58, 57, 73);
  box-shadow: rgb(25 25 39 / 25%) 0px 2px 6px 0px;
  padding: 5px;
  ${(props) => getTriangle()};
  ${(props: any) => getPosition(props.left, props.top)};
  z-index: 1000;
`;

export {
  StyledUsaMapChartWrapper,
  StyledMapFeatureSvg,
  StyledUsaMapChartTooltip
};
